// src/Callback.js
import React, { useEffect, useContext } from 'react';
import { AuthContext } from 'react-oauth2-code-pkce';

const Callback = () => {
  const context = useContext(AuthContext);
  const authService = context?.authService;

  useEffect(() => {
    if (!authService) return;

    authService.handleRedirectCallback().then(() => {
      window.location.replace('/');
    }).catch(err => {
      console.error('Callback error:', err);
    });
  }, [authService]);

  if (!authService) {
    return <div>Waiting for auth service...</div>;
  }

  return <div>Completing login...</div>;
};

export default Callback;
